const actions = {
  SET_STATE: "monitoring/SET_STATE",
  LIST: "monitoring/LIST",
  LIST_GENERAL: "monitoring/LIST_GENERAL",
  CREATE: "monitoring/CREATE",
  DETAIL: "monitoring/DETAIL",
  UPDATE: "monitoring/UPDATE",
  DELETE: "monitoring/DELETE",
};

export default actions;
